<template>
  <v-card>
    <v-card-title>
      Itens
      <v-spacer />
      <v-btn color="#FF562B" @click="abrirDialogNovo" dark
        ><i class="mdi mdi-plus"></i>Adicionar</v-btn
      >
    </v-card-title>

    <v-data-table :headers="headers" :items="items" :loading="loading" class="elevation-1">
      <template v-slot:[`item.price`]="{ item }"> {{ formataPreco(item.price) }} </template>

      <template v-slot:[`item.price_sell`]="{ item }">
        {{ formataPreco(item.price_sell) }}
      </template>

      <template v-slot:[`item.is_active`]="{ item }">
        <i v-if="item.is_active" class="mdi mdi-check text--success"></i>
        <i v-else class="mdi mdi-close text--error"></i>
      </template>

      <template v-slot:[`item.percent`]="{ item }"> {{ item.percent }}% </template>

      <template v-slot:[`item.acoes`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              color="default"
              v-bind="attrs"
              v-on="on"
              @click="abrirDialogEditar(item)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon small color="red" v-bind="attrs" v-on="on" @click="solicitarExclusao(item)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>Excluir</span>
        </v-tooltip>
        <AlertaModal v-model="alerta" :mensagem="mensagem" :titulo="'Atenção!'" />
      </template>
    </v-data-table>

    <!-- Formulário (criação/edição) -->
    <ItemDialog
      :value="dialog"
      @input="dialog = $event"
      :item="itemSelecionado"
      @submit="salvarItem"
    />
    <ConfirmDialog
      :value="confirmDialogVisible"
      @input="confirmDialogVisible = $event"
      :message="`Tem certeza que deseja excluir o item '${itemSelecionado?.name}'?`"
      @confirm="confirmarExclusao"
    />
  </v-card>
</template>

<script>
import ItemDialog from '../../components/Modais/ItemForm.vue';
import ConfirmDialog from '../../components/Modais/ConfirmDialog.vue';
import {
  getItems,
  deleteItem,
  getItem,
  updateItem,
  storeItem,
} from '../../services/estoque/item-servico';
import AlertaModal from '../Modais/AlertaModal.vue';
import _utils from '../../utils/utils.js';
export default {
  name: 'ItemList',
  components: { ItemDialog, ConfirmDialog, AlertaModal },

  data() {
    return {
      items: [],
      confirmDialogVisible: false,
      loading: false,
      dialog: false,
      itemSelecionado: null,
      alerta: false,
      mensagem: '',
      headers: [
        { text: 'Nome', value: 'name' },
        { text: 'SKU', value: 'sku' },
        { text: 'Preço', value: 'price' },
        { text: '% Lucro', value: 'percent' },
        { text: 'Preço Venda', value: 'price_sell' },
        { text: 'Ativo', value: 'is_active' },
        { text: 'Ações', value: 'acoes', sortable: false },
      ],
    };
  },

  mounted() {
    this.recarregarItems();
  },

  computed: {
    formataPreco() {
      return value => {
        return _utils.formatarDinheiro(value);
      };
    },
  },

  methods: {
    async recarregarItems() {
      this.loading = true;
      try {
        this.items = await getItems();
        console.log(this.items);
      } catch (e) {
        console.error('Erro ao listar itens:', e);
      } finally {
        this.loading = false;
      }
    },
    async salvarItem(item) {
      try {
        if (item.id) {
          await updateItem(item.id, item);
        } else {
          await storeItem(item);
        }

        this.dialog = false;
        this.recarregarItems();
      } catch (e) {
        console.error('Erro ao salvar item:', e);
        alert(e.response?.data?.detail || 'Erro ao salvar.');
      }
    },

    abrirDialogNovo() {
      this.itemSelecionado = {};
      this.dialog = true;
    },

    async abrirDialogEditar(item) {
      try {
        const data = await getItem(item.id);
        this.itemSelecionado = data;
        this.dialog = true;
      } catch (e) {
        console.error('Erro ao buscar item:', e);
      }
    },

    solicitarExclusao(item) {
      this.itemSelecionado = item;
      this.confirmDialogVisible = true;
    },

    async confirmarExclusao() {
      try {
        await deleteItem(this.itemSelecionado.id);
        this.recarregarItems();
        this.itemSelecionado = null;
      } catch (e) {
        // console.error('Erro ao excluir:', e);
        this.alerta = true;
        this.mensagem = 'Existem saldos de estoque vinculados ao item. Dê baixa primeiro.';
      }
    },

    fecharDialog() {
      this.dialog = false;
    },
  },
};
</script>
